import { IMessage, MessageType } from "atlas-shared";
import "./conversation.chat_session.scss";
import { getCreatedDate, timeSince } from "@Utils";
import { t } from "i18next";

interface IProps {
  message: IMessage;
}

export const ConversationChatMessage = ({ message }: IProps) => {
  const isSystemMessage = message.type === MessageType.SYSTEM_MESSAGE;

  const timestamp = timeSince(t, new Date(getCreatedDate(message) || ""), false, true, false);

  const messageClasses = isSystemMessage
    ? "chat-message system-message"
    : `chat-message ${message.direction}`;

  return (
    <div className={messageClasses}>
      <div className="chat-message-timestamp">{timestamp}</div>
      <div className="chat-message-text">{message.text}</div>
    </div>
  );
};
